import { PageHeader } from "@portal/components/layout/PageHeader";
import { getDefaultTab, type Tab, TabBar } from "@portal/components/ui/TabBar";
import { useState } from "react";
import { AdminUserMenu } from "../settings/AdminUserMenu";
import { AdminHeaderActionButtons } from "../shared/AdminHeaderActionButtons";
import { BulkLoadTab } from "./BulkLoadTab";
import { FredSnapshotTab } from "./FredSnapshotTab";
import { PelPmlCalculatorTab } from "./PelPmlCalculatorTab";
import { SfaaClassExperienceExplorer } from "./SfaaClassExperienceExplorer";
import { SfaaLossRatioTab } from "./SfaaLossRatioTab";

const TABS: [Tab<object>, ...Tab<object>[]] = [
	{ id: "pel-pml", label: "PEL/PML Calculator", Component: PelPmlCalculatorTab, isDefault: true },
	{ id: "econ-snapshot", label: "Economic Snapshot", Component: FredSnapshotTab },
	{ id: "sfaa-loss-ratio", label: "Loss Ratios", Component: SfaaLossRatioTab },
	{ id: "sfaa-data", label: "Raw SFAA Data", Component: SfaaClassExperienceExplorer },
	{ id: "bulk-load", label: "Bulk Load SFAA Class Data", Component: BulkLoadTab },
];

export const AdminMarketAnalyticsView = () => {
	const [selectedTab, setSelectedTab] = useState(getDefaultTab(TABS));
	const TabContent = selectedTab.Component;

	return (
		<div className="flex flex-col w-full h-full pb-8 gap-3">
			<PageHeader
				className="shrink-0"
				title="Market Analytics"
				testId="admin-market-analytics-view"
				userMenu={<AdminUserMenu />}
				actionButtons={<AdminHeaderActionButtons />}
			/>
			<div className="px-8 shrink-0">
				<TabBar
					options={TABS}
					activeTabId={selectedTab.id}
					onTabChange={(tabId) => {
						const tab = TABS.find(({ id }) => id === tabId);
						if (tab) setSelectedTab(tab);
					}}
					trackingPrefix="market-analytics"
				/>
			</div>
			<div className="flex-grow min-h-0 overflow-hidden px-8">
				<TabContent />
			</div>
		</div>
	);
};
